var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "activitycenter-page" },
    [
      _c("header-cmp"),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("footer-cmp")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "page-part banner banner_activity" }, [
      _c("h1", { staticClass: "banner-title" }, [
        _vm._v("玩转世界杯  周周抽大奖")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "banner-detail" }, [
        _vm._v("\n        活动时间：2018年6月14日-2018年7月11日\n        "),
        _c("br"),
        _vm._v(" 参与用户：所有通过我司APP自主下单的客户\n        "),
        _c("br"),
        _vm._v(" 参与方式：打开享运货主APP点击活动页即可参与\n        "),
        _c("br")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "page-part content", attrs: { id: "activity" } },
      [
        _c("div", { staticClass: "page-inner" }, [
          _c("h1", { staticClass: "page-title" }, [_vm._v("活动内容")]),
          _vm._v(" "),
          _c("div", { staticClass: "content-container" }, [
            _c("section", [
              _c("h3", { staticClass: "content-title" }, [
                _vm._v("A 活动规则")
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "1、参与条件：为答谢客户，在世界杯期间（6.14-7.15），凡通过我司APP自主下单的客户，即可参加抽奖活动。（自主通过APP下单发货，通过电话，微信，QQ等渠道下单的客户不能参加）\n2、抽奖时间和抽奖对象：\n（1）、6月21日（6.14 0:00-6.20 24点期间下单客户）；\n（2）、6月28日（6.21 0:00-6.27 24点期间下单客户）；\n（3）、7月05日（6.28 0:00-7.4  24点期间下单客户）；\n（4）、7月12日（7.5 0:00-7.11  24点期间下单客户）；\n3、每个账户在每个抽奖时间内只能参与一次；\n            "
                )
              ])
            ]),
            _vm._v(" "),
            _c("section", [
              _c("h3", { staticClass: "content-title" }, [
                _vm._v("B 领奖方式")
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "1、满足条件的货主用户在以上抽奖时间点打开享运货主APP抽奖；\n2、中奖客户填写领奖信息：姓名，电话，快递地址；奖品在5个工作日内快递到货；\n3、奖项设置：每个抽奖日抽取一二三四等奖各1个，参与奖8个。\n一等奖（小米电饭煲一台）；二等奖（小米热水壶一台）；三等奖（小米汤锅一个）；四等奖（手环一只）；参与奖（湿普乐高级湿巾大礼包一份）。\n            "
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pic-container" }),
          _vm._v(" "),
          _c("section", { staticStyle: { overflow: "hidden" } }, [
            _c("h3", { staticClass: "content-title" }, [_vm._v("C 活动奖品")]),
            _vm._v(" "),
            _c("div", { staticClass: "content-pics" }, [
              _c("div", { staticClass: "pic-detail" }, [
                _c("img", {
                  attrs: {
                    src: require("../assets/images/page_activitycenter/prize1.png"),
                    alt: "小米电饭煲"
                  }
                }),
                _vm._v(" "),
                _c("h3", [_vm._v("一等奖")]),
                _vm._v(" "),
                _c("p", [_vm._v("小米电饭煲一台")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pic-detail" }, [
                _c("img", {
                  attrs: {
                    src: require("../assets/images/page_activitycenter/prize2.png"),
                    alt: "小米热水壶"
                  }
                }),
                _vm._v(" "),
                _c("h3", [_vm._v("二等奖")]),
                _vm._v(" "),
                _c("p", [_vm._v("小米热水壶一台")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pic-detail" }, [
                _c("img", {
                  attrs: {
                    src: require("../assets/images/page_activitycenter/prize3.png"),
                    alt: "小米汤锅"
                  }
                }),
                _vm._v(" "),
                _c("h3", [_vm._v("三等奖")]),
                _vm._v(" "),
                _c("p", [_vm._v("小米汤锅一个")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pic-detail" }, [
                _c("img", {
                  attrs: {
                    src: require("../assets/images/page_activitycenter/prize4.png"),
                    alt: "智能手环"
                  }
                }),
                _vm._v(" "),
                _c("h3", [_vm._v("四等奖")]),
                _vm._v(" "),
                _c("p", [_vm._v("智能手环一个")])
              ])
            ])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-4f1e5abe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-4f1e5abe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/activitycenter.vue
// module id = null
// module chunks = 